import axios from 'axios';
import { saveAs } from 'file-saver';
import { getNonGwApiRoot } from '../../constants/ParamountReactConstants';
import { BlockType } from '../../../types/receiver';

export function fetchReceiverScorecardStats(receiverId: number) {
  return {
    type: 'FETCH_RECEIVER_SCORECARD_STATS',
    payload: axios.get(`${getNonGwApiRoot()}/distribution/receivers/${receiverId}/scorecard-stats`),
    meta: { receiverId },
  };
}

export function refreshReceiverScorecardStats(receiverId: number) {
  return {
    type: 'REFRESH_RECEIVER_SCORECARD_STATS',
    payload: axios.post(
      `${getNonGwApiRoot()}/distribution/receivers/${receiverId}/scorecard-stats/refresh`,
      { forceRecalculate: true, notifyOnCompletion: true }
    ),
    meta: { receiverId },
  };
}

export function checkJobStatus(jobId: string) {
  return {
    type: 'CHECK_JOB_STATUS',
    payload: axios.get(`${getNonGwApiRoot()}/jobs/${jobId}/status`),
    meta: { jobId },
  };
}

export function setScorecardBlockOrder(blockOrder: BlockType[]) {
  return {
    type: 'SET_SCORECARD_BLOCK_ORDER',
    payload: blockOrder,
  };
}

export function searchReceiverScorecardPartNumbers(
  receiverId: number,
  params: {
    page?: number;
    limit?: number;
    search?: string;
    sort?: string;
    order?: string;
  } = {}
) {
  const urlParams = [];
  if (params.page !== undefined) urlParams.push({ name: 'page', values: params.page });
  if (params.limit !== undefined) urlParams.push({ name: 'limit', values: params.limit });
  if (params.search) urlParams.push({ name: 'search', values: params.search });
  if (params.sort) urlParams.push({ name: 'sort', values: params.sort });
  if (params.order) urlParams.push({ name: 'order', values: params.order });

  const queryString =
    urlParams.length > 0
      ? `?${urlParams.map(p => `${p.name}=${encodeURIComponent(p.values)}`).join('&')}`
      : '';

  return {
    type: 'SEARCH_RECEIVER_SCORECARD_PART_NUMBERS',
    payload: axios.get(
      `${getNonGwApiRoot()}/distribution/receivers/${receiverId}/scorecard-part-numbers${queryString}`
    ),
    meta: { receiverId, params },
  };
}

export async function exportScorecardStats(
  receiverId: number,
  type: 'brand' | 'validation' | 'partNumber',
  receiverName?: string
) {
  const response = await axios.get(
    `${getNonGwApiRoot()}/distribution/receivers/${receiverId}/scorecard-stats/export`,
    {
      params: { type, format: 'csv' },
      responseType: 'blob',
    }
  );

  const contentDisposition = response.headers['content-disposition'];
  let filename = `${receiverName || 'receiver'}-${type}-${
    new Date().toISOString().split('T')[0]
  }.csv`;

  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
    if (filenameMatch) {
      filename = filenameMatch[1];
    }
  }

  saveAs(response.data, filename);
  return { success: true };
}
